import { useAutoneTranslation } from '@autone/translations';
import { type FC, useMemo } from 'react';

import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '../../../../atoms';
import { type DatasetsDataFreshnessStatus } from '../DataFreshnessWidget.types';

import { alertTitleMap, alertVariantMap } from './utils';
interface DataFreshnessAlertProps {
  status: DatasetsDataFreshnessStatus;
}

export const DataFreshnessAlert: FC<DataFreshnessAlertProps> = ({ status }) => {
  const { common } = useAutoneTranslation();

  const variant = useMemo(() => status && alertVariantMap[status], [status]);

  const title = useMemo(
    () => status && common(alertTitleMap[status]),
    [common, status],
  );

  const subtitle = common(
    'data-age.global-widget.details-sidesheet.status-banner.description',
  );

  if (!variant || !title) return null;

  return (
    <Alert variant={variant} className="!p-2.5">
      <AlertIcon variant={variant} size="sm" />
      <AlertTitle className="text-base">{title}</AlertTitle>
      <AlertDescription>{subtitle}</AlertDescription>
    </Alert>
  );
};
